import { render, staticRenderFns } from "./icon-jifen.vue?vue&type=template&id=f04c4d76&scoped=true&"
import script from "./icon-jifen.vue?vue&type=script&lang=js&"
export * from "./icon-jifen.vue?vue&type=script&lang=js&"
import style0 from "./icon-jifen.vue?vue&type=style&index=0&id=f04c4d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04c4d76",
  null
  
)

export default component.exports